import Label from './Label.vue'
import LabelProps from './propsMixin'

export { Label, LabelProps }
export default Label
